import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { GrupoPatrimonioService } from '../services/api/cadastros/GrupoPatrimonioService';


type TAutoCompleteOption = {
  idgrupopatrimonio: string;
  label: string;
  veiculos: boolean;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  veiculos?: (novoTextoselect: boolean | undefined) => void;
}
export const AutoCompleteGpPatrimonio: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, veiculos }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idgrupopatrimonio');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      GrupoPatrimonioService.getAlllist(busca, selectedId)
        .then((result) => {
          setIsLoading(false); 

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(grupoPatrimonio => ({ idgrupopatrimonio: grupoPatrimonio.idgrupopatrimonio, label: grupoPatrimonio.descricao, veiculos: grupoPatrimonio.veiculos})));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idgrupopatrimonio === selectedId);
    if (!selectedOption) return null;

    return selectedOption; 
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idgrupopatrimonio); setBusca(''); veiculos?.(newValue?.veiculos); clearError(); }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Grupo de Patrimônio"   
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};